import { showKAlert } from '../helpers'
import { t } from '../locale'
import { checkCredit } from '../service/subscription'

// Pre-flight guard for a point-spending service. SES/AES fail open (the server's own
// deduction is the source of truth); QES fails closed, since its price and first-use
// state come from the backend and a bad lookup must block confirmation.
export async function ensureEnoughCredit(service: string, count?: number): Promise<boolean> {
  const isQes = service === 'ds-sign-qes'

  try {
    const res = await checkCredit(service, count)

    if (isQes && res?.qesUnavailable) {
      showKAlert('danger', t('qesPriceUnavailable'))
      return false
    }

    if (isQes && res?.qesPending) {
      showKAlert('warning', t('qesFirstUsePending'))
      return false
    }

    if (res?.allowed === false) {
      showKAlert('danger', t('notEnoughCredit'))
      return false
    }

    if (isQes && (typeof res?.cost !== 'number' || typeof res?.firstUse !== 'boolean')) {
      showKAlert('danger', t('qesPriceUnavailable'))
      return false
    }

    return true
  } catch {
    if (isQes) {
      showKAlert('danger', t('qesPriceUnavailable'))
      return false
    }

    return true
  }
}
